import React from 'react';
const links = [{
  label: 'support@screenandadapt.com [placeholder]',
  href: 'mailto:support@screenandadapt.com'
}, {
  label: '@screenandadapt [placeholder]',
  href: '#'
}, {
  label: 'Terms & Conditions',
  href: '#'
}, {
  label: 'Privacy Policy',
  href: '#'
}];
export function Footer() {
  return <footer className="w-full bg-ink text-white/70" data-id="element-148" data-mp="36ooa5jo5xlvb">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8" data-id="element-149" data-mp="36n3d9nedlqua">
        <p className="font-serif text-2xl font-semibold text-white" data-id="element-150" data-mp="3ugbrb9vmhike">
          Screen &amp; Adapt™ — Yoga Edition
        </p>
        <p className="mt-3 max-w-2xl font-sans text-[15px] leading-[1.6] text-white/60" data-id="element-151" data-mp="36msyjwt2ysh">
          Receive. Check. Offer. Close the loop. — The decision system for yoga teachers who'd
          rather be prepared than certain.
        </p>

        <p className="mt-10 max-w-3xl border-t border-white/10 pt-8 font-sans text-[12px] leading-[1.7] text-white/65" data-id="element-152" data-mp="29ynlrlrph7ej">
          Screen &amp; Adapt™ is an educational resource for yoga teachers. It does not diagnose,
          treat, or replace care from a licensed health professional, and nothing in it is medical
          advice. Clinical content reviewed by [Reviewer name, credentials].
        </p>

        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-153" data-mp="3v7zx9gwsuynb">
          {links.map(link => <li key={link.label} data-id="element-154" data-mp="3q8dk17gz1iei">
              <a href={link.href} className="font-sans text-[14px] text-white/70 underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline" data-id="element-155" data-mp="3q727ai5jt0b9">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 font-sans text-[12px] text-white/60" data-id="element-156" data-mp="hs21ffdaqyhm">
          © 2026 Screen &amp; Adapt™. All rights reserved.
        </p>
      </div>
    </footer>;
}